module.exports = window["dfShared"]["tooltip"];